/* tslint:disable */
/* eslint-disable */
/**
 * Main API v1.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { AggregateKeyInfo } from './AggregateKeyInfo';
import {
    AggregateKeyInfoFromJSON,
    AggregateKeyInfoFromJSONTyped,
    AggregateKeyInfoToJSON,
} from './AggregateKeyInfo';
import type { EmailDto } from './EmailDto';
import {
    EmailDtoFromJSON,
    EmailDtoFromJSONTyped,
    EmailDtoToJSON,
} from './EmailDto';
import type { TelephoneDto } from './TelephoneDto';
import {
    TelephoneDtoFromJSON,
    TelephoneDtoFromJSONTyped,
    TelephoneDtoToJSON,
} from './TelephoneDto';

/**
 * 
 * @export
 * @interface TuteurLieuDoublonSearchDto
 */
export interface TuteurLieuDoublonSearchDto {
    /**
     * 
     * @type {number}
     * @memberof TuteurLieuDoublonSearchDto
     */
    idtuteur?: number | null;
    /**
     * 
     * @type {number}
     * @memberof TuteurLieuDoublonSearchDto
     */
    idlieuFormation?: number;
    /**
     * 
     * @type {string}
     * @memberof TuteurLieuDoublonSearchDto
     */
    nom?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TuteurLieuDoublonSearchDto
     */
    prenom?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TuteurLieuDoublonSearchDto
     */
    registreNational?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof TuteurLieuDoublonSearchDto
     */
    dateNaissance?: Date | null;
    /**
     * 
     * @type {string}
     * @memberof TuteurLieuDoublonSearchDto
     */
    nationalite?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TuteurLieuDoublonSearchDto
     */
    codesexe?: string | null;
    /**
     * 
     * @type {TelephoneDto}
     * @memberof TuteurLieuDoublonSearchDto
     */
    gsm?: TelephoneDto;
    /**
     * 
     * @type {TelephoneDto}
     * @memberof TuteurLieuDoublonSearchDto
     */
    telephone?: TelephoneDto;
    /**
     * 
     * @type {EmailDto}
     * @memberof TuteurLieuDoublonSearchDto
     */
    email?: EmailDto;
    /**
     * 
     * @type {string}
     * @memberof TuteurLieuDoublonSearchDto
     */
    remarque?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof TuteurLieuDoublonSearchDto
     */
    dateCv?: Date | null;
    /**
     * 
     * @type {boolean}
     * @memberof TuteurLieuDoublonSearchDto
     */
    anneesExperience?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof TuteurLieuDoublonSearchDto
     */
    tutorat?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof TuteurLieuDoublonSearchDto
     */
    vdc?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof TuteurLieuDoublonSearchDto
     */
    derogation?: boolean;
    /**
     * 
     * @type {string}
     * @memberof TuteurLieuDoublonSearchDto
     */
    responsableDerogation?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof TuteurLieuDoublonSearchDto
     */
    dateDerogation?: Date | null;
    /**
     * 
     * @type {Array<number>}
     * @memberof TuteurLieuDoublonSearchDto
     */
    idmetiers?: Array<number> | null;
    /**
     * 
     * @type {number}
     * @memberof TuteurLieuDoublonSearchDto
     */
    idpersonne?: number | null;
    /**
     * 
     * @type {Array<number>}
     * @memberof TuteurLieuDoublonSearchDto
     */
    selectedIds?: Array<number> | null;
    /**
     * 
     * @type {Array<number>}
     * @memberof TuteurLieuDoublonSearchDto
     */
    availableIds?: Array<number> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof TuteurLieuDoublonSearchDto
     */
    sortKey?: Array<string> | null;
    /**
     * 
     * @type {Array<AggregateKeyInfo>}
     * @memberof TuteurLieuDoublonSearchDto
     */
    aggregateKeys?: Array<AggregateKeyInfo> | null;
    /**
     * 
     * @type {number}
     * @memberof TuteurLieuDoublonSearchDto
     */
    forceSkip?: number | null;
    /**
     * 
     * @type {number}
     * @memberof TuteurLieuDoublonSearchDto
     */
    forceTake?: number | null;
    /**
     * 
     * @type {any}
     * @memberof TuteurLieuDoublonSearchDto
     */
    parameters?: any | null;
    /**
     * 
     * @type {string}
     * @memberof TuteurLieuDoublonSearchDto
     */
    filter?: string | null;
}

/**
 * Check if a given object implements the TuteurLieuDoublonSearchDto interface.
 */
export function instanceOfTuteurLieuDoublonSearchDto(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function TuteurLieuDoublonSearchDtoFromJSON(json: any): TuteurLieuDoublonSearchDto {
    return TuteurLieuDoublonSearchDtoFromJSONTyped(json, false);
}

export function TuteurLieuDoublonSearchDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): TuteurLieuDoublonSearchDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'idtuteur': !exists(json, 'idtuteur') ? undefined : json['idtuteur'],
        'idlieuFormation': !exists(json, 'idlieuFormation') ? undefined : json['idlieuFormation'],
        'nom': !exists(json, 'nom') ? undefined : json['nom'],
        'prenom': !exists(json, 'prenom') ? undefined : json['prenom'],
        'registreNational': !exists(json, 'registreNational') ? undefined : json['registreNational'],
        'dateNaissance': !exists(json, 'dateNaissance') ? undefined : (json['dateNaissance'] === null ? null : new Date(json['dateNaissance'])),
        'nationalite': !exists(json, 'nationalite') ? undefined : json['nationalite'],
        'codesexe': !exists(json, 'codesexe') ? undefined : json['codesexe'],
        'gsm': !exists(json, 'gsm') ? undefined : TelephoneDtoFromJSON(json['gsm']),
        'telephone': !exists(json, 'telephone') ? undefined : TelephoneDtoFromJSON(json['telephone']),
        'email': !exists(json, 'email') ? undefined : EmailDtoFromJSON(json['email']),
        'remarque': !exists(json, 'remarque') ? undefined : json['remarque'],
        'dateCv': !exists(json, 'dateCv') ? undefined : (json['dateCv'] === null ? null : new Date(json['dateCv'])),
        'anneesExperience': !exists(json, 'anneesExperience') ? undefined : json['anneesExperience'],
        'tutorat': !exists(json, 'tutorat') ? undefined : json['tutorat'],
        'vdc': !exists(json, 'vdc') ? undefined : json['vdc'],
        'derogation': !exists(json, 'derogation') ? undefined : json['derogation'],
        'responsableDerogation': !exists(json, 'responsableDerogation') ? undefined : json['responsableDerogation'],
        'dateDerogation': !exists(json, 'dateDerogation') ? undefined : (json['dateDerogation'] === null ? null : new Date(json['dateDerogation'])),
        'idmetiers': !exists(json, 'idmetiers') ? undefined : json['idmetiers'],
        'idpersonne': !exists(json, 'idpersonne') ? undefined : json['idpersonne'],
        'selectedIds': !exists(json, 'selectedIds') ? undefined : json['selectedIds'],
        'availableIds': !exists(json, 'availableIds') ? undefined : json['availableIds'],
        'sortKey': !exists(json, 'sortKey') ? undefined : json['sortKey'],
        'aggregateKeys': !exists(json, 'aggregateKeys') ? undefined : (json['aggregateKeys'] === null ? null : (json['aggregateKeys'] as Array<any>).map(AggregateKeyInfoFromJSON)),
        'forceSkip': !exists(json, 'forceSkip') ? undefined : json['forceSkip'],
        'forceTake': !exists(json, 'forceTake') ? undefined : json['forceTake'],
        'parameters': !exists(json, 'parameters') ? undefined : json['parameters'],
        'filter': !exists(json, 'filter') ? undefined : json['filter'],
    };
}

export function TuteurLieuDoublonSearchDtoToJSON(value?: TuteurLieuDoublonSearchDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'idtuteur': value.idtuteur,
        'idlieuFormation': value.idlieuFormation,
        'nom': value.nom,
        'prenom': value.prenom,
        'registreNational': value.registreNational,
        'dateNaissance': value.dateNaissance === undefined ? undefined : (value.dateNaissance === null ? null : value.dateNaissance.toISOString()),
        'nationalite': value.nationalite,
        'codesexe': value.codesexe,
        'gsm': TelephoneDtoToJSON(value.gsm),
        'telephone': TelephoneDtoToJSON(value.telephone),
        'email': EmailDtoToJSON(value.email),
        'remarque': value.remarque,
        'dateCv': value.dateCv === undefined ? undefined : (value.dateCv === null ? null : value.dateCv.toISOString()),
        'anneesExperience': value.anneesExperience,
        'tutorat': value.tutorat,
        'vdc': value.vdc,
        'derogation': value.derogation,
        'responsableDerogation': value.responsableDerogation,
        'dateDerogation': value.dateDerogation === undefined ? undefined : (value.dateDerogation === null ? null : value.dateDerogation.toISOString()),
        'idmetiers': value.idmetiers,
        'idpersonne': value.idpersonne,
        'selectedIds': value.selectedIds,
        'availableIds': value.availableIds,
        'sortKey': value.sortKey,
        'aggregateKeys': value.aggregateKeys === undefined ? undefined : (value.aggregateKeys === null ? null : (value.aggregateKeys as Array<any>).map(AggregateKeyInfoToJSON)),
        'forceSkip': value.forceSkip,
        'forceTake': value.forceTake,
        'parameters': value.parameters,
        'filter': value.filter,
    };
}

